export const doctorNameLabel = (name) => {
  const cleanName = String(name || '').trim().replace(/^dr(?:a)?\.?\s+/i, '');
  return cleanName ? `Dr. ${cleanName}` : 'Médico não informado';
};
